__turbopack_context__.v({
  "action": "MentionCard-module__2w4Bna__action",
  "card": "MentionCard-module__2w4Bna__card",
  "description": "MentionCard-module__2w4Bna__description",
  "product": "MentionCard-module__2w4Bna__product",
  "unavailable": "MentionCard-module__2w4Bna__unavailable",
  "value": "MentionCard-module__2w4Bna__value",
});
